export default {
  Auth: {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_VrvQrGCD4',
    userPoolWebClientId: '6omk2os9trv1i27cpj2v94gdr6',
    mandatorySignIn: true
  }
}
